import optionsHelper from '@cordel/helpers/form/select/options';

import { percentize } from '@/helpers/filters';
import { select, input, boolean } from '@/_CRUDL/helpers/form/fields';

import commercialMap, {
  storesMap,
  paymentsMap,
  pricesMap,
  returnsMap,
  productsMap,
} from '@/views/Settings/Commercial/Form/maps';

import defaultReturnOptions from '@/views/Settings/Commercial/Form/helpers';

export const defaultSectionIDs = {
  store_association: 'storeAssociation',
  commercial_association: 'commercialAssociation',
  commercial_settings: 'commercialSettings',
  commercial_products: 'commercialProducts',
  commercial_priorities: 'commercialPriorities',
};

function defaultSections() {
  const sections = [{
    id: defaultSectionIDs.store_association,
    title: 'Regras gerais',
    subtitle: 'Onde as regras serão aplicadas',
    items: [{
      ...select,
      id: storesMap.store_id,
      label: 'Loja',
      placeholder: 'Selecione uma loja',
      size: 2,
      validations: [{
        type: 'blank',
      }],
    }, {
      id: storesMap.store_separator,
      separator: true,
    }],
  }];

  return sections;
}

export function commercialSections(options = {}) {
  return defaultSections().concat({
    id: defaultSectionIDs.commercial_association,
    title: null,
    subtitle: null,
    items: [{
      ...boolean,
      id: commercialMap.has_bank,
      label: 'Incluir banco?',
      placeholder: 'Incluir banco na condição?',
    }, {
      ...select,
      id: commercialMap.bank_id,
      label: 'Banco',
      placeholder: 'Selecione um banco',
      size: 2,
    }, {
      id: commercialMap.bank_separator,
      separator: true,
    }, {
      ...boolean,
      id: commercialMap.has_vehicle,
      label: 'Incluir veículo?',
      placeholder: 'Incluir veículo na condição?',
    }, {
      ...select,
      id: commercialMap.vehicle_model_id,
      label: 'Veículo',
      placeholder: 'Selecione um veículo',
      size: 2,
    }].filter(field => !(options.pullOutFields || []).includes(field.id)),
  });
}

export function productsSections() {
  return commercialSections()
    .concat({
      id: defaultSectionIDs.commercial_products,
      title: 'Produtos',
      subtitle: 'As opções abaixo podem não estar presentes em todos os bancos ou condições',
      items: [{
        ...boolean,
        id: productsMap.include_financial_protection_insurance,
        label: 'Incluir Seguro de Proteção Financeira?',
        value: 'false',
      }, {
        ...boolean,
        id: productsMap.include_capitalization_bond,
        label: 'Incluir Título de Capitalização?',
        value: 'false',
      }, {
        ...boolean,
        id: productsMap.include_asset_insurance,
        label: 'Incluir Seguro do Bem?',
        value: 'false',
      }, {
        ...boolean,
        id: productsMap.include_personal_insurance,
        label: 'Incluir Seguro de Acidentes?',
        value: 'false',
      }],
    });
}


export function pricesSections() {
  return commercialSections({
    pullOutFields: [
      commercialMap.has_vehicle,
      commercialMap.bank_separator,
      commercialMap.has_bank,
      commercialMap.bank_id,
    ],
  }).concat({
    id: defaultSectionIDs.commercial_settings,
    title: 'Valores padrão',
    subtitle: 'Configurações da regra',
    items: [{
      ...input,
      id: pricesMap.default_price_cents,
      label: 'Valor padrão de venda',
      mask: {
        type: 'monetize',
      },
      placeholder: 'R$ 0,00',
      validations: [{
        type: 'blank',
      }, {
        count: 0,
        type: 'greaterThan',
      }],
    },
    {
      ...input,
      id: pricesMap.min_price_cents,
      label: 'Valor mínimo de venda',
      mask: {
        type: 'monetize',
      },
      placeholder: 'R$ 0,00',
    }],
  });
}

export function returnsSections() {
  return commercialSections()
    .concat({
      id: defaultSectionIDs.commercial_settings,
      title: 'Regras de retorno',
      subtitle: 'Retornos que serão considerados como filtro nas simulações e propostas da sua loja',
      items: [{
        ...input,
        id: returnsMap.min_return,
        label: 'Retorno mínimo',
        mask: {
          format: '##',
          bigFormat: '##',
          type: 'patternize',
        },
        placeholder: '0',
        validations: [{
          type: 'blank',
        }, {
          count: 0,
          equal: true,
          type: 'greaterThan',
        }],
      }, {
        ...input,
        id: returnsMap.max_return,
        label: 'Retorno máximo',
        mask: {
          format: '##',
          bigFormat: '##',
          type: 'patternize',
        },
        placeholder: '0',
        validations: [],
      }],
    });
}

export function prioritiesSections() {
  return returnsSections()
    .concat({
      id: defaultSectionIDs.commercial_priorities,
      title: 'Regras de prioridade',
      subtitle: 'Critérios que irão prevalecer para exibir o resultado final das simulações',
      items: [{
        ...select,
        id: returnsMap.return_preference,
        label: 'Retorno',
        placeholder: 'Retorno prioritário',
        options: optionsHelper(defaultReturnOptions),
      }, {
        ...select,
        id: returnsMap.quota_preference,
        label: 'Parcela',
        placeholder: 'Parcela prioritária',
        options: optionsHelper(defaultReturnOptions),
      }],
    });
}

export function paymentsSections() {
  return commercialSections().concat({
    id: defaultSectionIDs.commercial_settings,
    title: 'Porcentagens de entrada',
    subtitle: 'Configurações da regra',
    items: [{
      ...input,
      id: paymentsMap.min_pct,
      label: 'Porcentagem mínima',
      placeholder: '0%',
      mask: {
        type: 'monetize',
        prefix: '',
        suffix: '%',
      },
      validations: [{
        type: 'blank',
      }, {
        type: 'lessThan',
        count: 100 * 100,
        equal: true,
        formatter: percentize,
      }],
    }],
  });
}

export default defaultSections;
